<script setup>

import AppLayout from "@/Layouts/AppLayout.vue";
import SecondaryButton from "@/Components/SecondaryButton.vue";
import {ref} from "vue";
import {Inertia} from "@inertiajs/inertia";
import InputLabel from "@/Components/InputLabel.vue";
import TextInput from "@/Components/TextInput.vue";
import SelectInput from "@/Components/SelectInput.vue";
import PaginationLinks from "@/Components/PaginationLinks.vue";

const props = defineProps({
  users: Object,
  userTypes: Object,
  pageSearchQuery: String,
  userTypeQuery: String,
});
const searchQuery = ref(props.pageSearchQuery);
const userTypeQuery = ref(props.userTypeQuery);
const searching = ref(false);

const makeSearchRequest = _.debounce(() => {
  searching.value = true;
  const queryParameters = route().params || {};
  if (queryParameters.page) {
    delete queryParameters.page;
  }
  if (userTypeQuery.value === 0) {
    userTypeQuery.value = '0';
  }
  queryParameters['query'] = searchQuery.value || '';
  queryParameters['userType'] = userTypeQuery.value || '';
  Inertia.get(route(route().current(), queryParameters), {}, {preserveScroll: true});
  searching.value = false;
}, 400);
</script>

<template>
  <AppLayout title="Inactive Users">
    <template #header>
      <h2 class="font-semibold text-xl text-gray-800 leading-tight">
        Inactive Users
      </h2>
    </template>

    <div>
      <div class="mx-auto py-10 sm:px-6 lg:px-8">
        <div class="mt-5 mb-2 grid gap-2 xl:grid-cols-5 md:grid-cols-2 grid-cols-1">
          <div>
            <InputLabel for="search" value="Search" class="inline mr-2"/>
            <TextInput
              id="search"
              v-model="searchQuery"
              type="text"
              class="mt-1 inline"
              placeholder="John Doe"
              @keyup="makeSearchRequest"
              :disabled="searching"
            />
          </div>
          <div>
            <InputLabel for="userType" value="User Type" class="inline mr-2"/>
            <SelectInput id="userType" name="userType" v-model="userTypeQuery" @change="makeSearchRequest"
                    class="mt-1"
            >
              <option :value="null">Select</option>
              <option v-for="userType in userTypes" :value="userType.identifier"
                      v-text="userType.display_name"
              ></option>
            </SelectInput>
          </div>
          <div class="xl:text-right mb-2 md:col-span-2 xl:col-start-4">
            <SecondaryButton><a :href="route('admin.users.active')">View Active Users</a></SecondaryButton>
          </div>
        </div>

        <div class="overflow-x-auto">
          <table class="min-w-full w-full text-left text-sm font-light">
            <thead class="border-b font-medium dark:border-neutral-500">
            <tr>
              <th scope="col" class="px-4 py-2">First Name</th>
              <th scope="col" class="px-4 py-2">User Type</th>
              <th scope="col" class="px-4 py-2 hidden md:table-cell">Last Name</th>
              <th scope="col" class="px-4 py-2 hidden md:table-cell">Title</th>
              <th scope="col" class="px-4 py-2">Email</th>
              <th scope="col" class="px-4 py-2 hidden md:table-cell">Phone Number</th>
              <th scope="col" class="px-4 py-2">Actions</th>
            </tr>
            </thead>
            <tbody>
            <tr
              class="border-b transition duration-300 ease-in-out hover:bg-neutral-200"
              v-for="user in users.data">
              <td class="px-4 py-2 break-words" v-text="user.firstname"></td>
              <td class="px-4 py-2 break-words" v-text="userTypes[user.employeeType]?.display_name"></td>
              <td class="px-4 py-2 break-words hidden md:table-cell" v-text="user.lastname"></td>
              <td class="px-4 py-2 break-words hidden md:table-cell" v-text="user.title"></td>
              <td class="px-4 py-2 break-words" v-text="user.email"></td>
              <td class="px-4 py-2 break-words hidden md:table-cell" v-text="user.phone"></td>
              <td>
                <a :href="route('admin.users.edit', {user: user.employeeID})" class="fa fa-pen mr-1 p-1"
                   :title="`Edit ${user.firstname}`">
                </a>
              </td>
            </tr>
            </tbody>
          </table>
          <div class="text-center mt-5">
            <PaginationLinks :pagination="users"/>
          </div>
        </div>
      </div>
    </div>

  </AppLayout>
</template>
